import * as React from 'react';
import { IconButton,} from '@material-ui/core';
import {IFamilyMember} from "@app-types/websocket/family.types";
import TranslateNew from "@translate/TranslateNew";
import NewChatIcon from '@material-ui/icons/AddCommentOutlined';
import ChatIcon from '@material-ui/icons/QuestionAnswerTwoTone';
import * as ChatActions from '@services/chat/chat.actions';
import { Link } from 'react-router-dom';
import { connect } from 'react-redux';
import { ChatType, ICreateChat } from '@app-types/websocket/chat.types';
import { FamilyMemberType } from '@services/family/family.constants';
import { styleColors } from 'src/main.style';

const tn = TranslateNew.getInstance();

interface IProps
{
    chatId?: number;
    createChat: (data: ICreateChat) => void;
    callBack?: () => void;
    family: IFamilyMember[];
    referenceObject:number;
    chatType:ChatType;
    title:string;
    msg:string;

    waitForAgreementChat?:(id:number) => void;
    waitForPurchaseChat?:(id:number) => void;
    waitForTransferChat?:(id:number) => void;
}

class ChatButton extends React.Component<IProps> {

    public render()
    {
        const { createChat, chatId, family,referenceObject, title, msg,chatType } = this.props;


        if (chatId !== undefined) {
            return (
            <Link to={`/app/messages/${chatId}`} style={{zIndex:3}}>
                <IconButton style={{padding:'6px'}}>
                    <ChatIcon style={{fill:styleColors.deepPurple}} />
                </IconButton>
            </Link>);
        } else {
           return(<div style={{display: 'flex', alignItems: 'center'}}>
                <IconButton  style={{padding:'6px', zIndex:3}} onClick={() => {
                    createChat({  chatType: this.props.chatType,
                        participants: family.filter((mem) => mem.role === FamilyMemberType.PARENT).map((mem) => mem.id),
                        title, msg,referenceObject});
                    if (chatType === ChatType.AGREEMENT_CHAT && this.props.waitForAgreementChat !== undefined) {
                        this.props.waitForAgreementChat(referenceObject);
                    }
                    if (chatType === ChatType.PURCHASE_CHAT && this.props.waitForPurchaseChat !== undefined) {
                        this.props.waitForPurchaseChat(referenceObject);
                    }
                    if (chatType === ChatType.TRANSFER_CHAT && this.props.waitForTransferChat !== undefined) {
                        this.props.waitForTransferChat(referenceObject);
                    }
                    if (this.props.callBack) {this.props.callBack();}
                    }}>
                    <NewChatIcon />
                </IconButton>
           </div>);
        }

    }

    
}

const mapDispatchToProps = {
    createChat: ChatActions.createChat,
};

export default connect(null, mapDispatchToProps)(ChatButton);



// WEBPACK FOOTER //
// ./src/components/economy/ChatButton.tsx